!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.reactSpinners = n() : e.reactSpinners = n();
}(window, function () {
  return function (e) {
    var n = {};

    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) t.d(r, o, function (n) {
        return e[n];
      }.bind(null, o));
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 1);
  }([function (e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    });

    var r = function () {
      function e() {
        this.spinnerCache = new Set();
      }

      return e.prototype._register = function (e) {
        this.spinnerCache.add(e);
      }, e.prototype._unregister = function (e) {
        var n = this;
        this.spinnerCache.forEach(function (t) {
          t === e && n.spinnerCache.delete(t);
        });
      }, e.prototype._unregisterGroup = function (e) {
        var n = this;
        this.spinnerCache.forEach(function (t) {
          t.group === e && n.spinnerCache.delete(t);
        });
      }, e.prototype._unregisterAll = function () {
        this.spinnerCache.clear();
      }, e.prototype.show = function (e) {
        this.spinnerCache.forEach(function (n) {
          n.name === e && (n.show = !0);
        });
      }, e.prototype.hide = function (e) {
        this.spinnerCache.forEach(function (n) {
          n.name === e && (n.show = !1);
        });
      }, e.prototype.showGroup = function (e) {
        this.spinnerCache.forEach(function (n) {
          n.group === e && (n.show = !0);
        });
      }, e.prototype.hideGroup = function (e) {
        this.spinnerCache.forEach(function (n) {
          n.group === e && (n.show = !1);
        });
      }, e.prototype.showAll = function () {
        this.spinnerCache.forEach(function (e) {
          return e.show = !0;
        });
      }, e.prototype.hideAll = function () {
        this.spinnerCache.forEach(function (e) {
          return e.show = !1;
        });
      }, e.prototype.isShowing = function (e) {
        var n = void 0;
        return this.spinnerCache.forEach(function (t) {
          t.name === e && (n = t.show);
        }), n;
      }, e;
    }();

    n.SpinnerService = r;
    var o = new r();
    n.spinnerService = o;
  }, function (e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var r = t(2);
    n.Spinner = r.SpinnerComponent;
    var o = t(0);
    n.SpinnerService = o.SpinnerService, n.spinnerService = o.spinnerService;
  }, function (e, n, t) {
    "use strict";

    var r,
        o = this && this.__extends || (r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, n) {
      e.__proto__ = n;
    } || function (e, n) {
      for (var t in n) n.hasOwnProperty(t) && (e[t] = n[t]);
    }, function (e, n) {
      function t() {
        this.constructor = e;
      }

      r(e, n), e.prototype = null === n ? Object.create(n) : (t.prototype = n.prototype, new t());
    });
    Object.defineProperty(n, "__esModule", {
      value: !0
    });

    var i = t(3),
        p = t(0),
        s = function (e) {
      function n() {
        var n = null !== e && e.apply(this, arguments) || this;
        return n.spinnerService = p.spinnerService, n;
      }

      return o(n, e), Object.defineProperty(n.prototype, "show", {
        get: function get() {
          return this.state.show;
        },
        set: function set(e) {
          this.setState({
            show: e
          });
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(n.prototype, "name", {
        get: function get() {
          return this.props.name;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(n.prototype, "group", {
        get: function get() {
          return this.props.group;
        },
        enumerable: !0,
        configurable: !0
      }), n.prototype.componentWillMount = function () {
        this.setState({
          show: !!this.props.hasOwnProperty("show") && this.props.show
        }), this.props.hasOwnProperty("spinnerService") && (this.spinnerService = this.props.spinnerService), this.spinnerService._register(this);
      }, n.prototype.componentWillUnmount = function () {
        this.spinnerService._unregister(this);
      }, n.prototype.render = function () {
        if (this.state.show) {
          var e = this.props.loadingImage;
          return i.createElement("div", {
            style: {
              display: "inline-block"
            }
          }, e && i.createElement("img", {
            src: e
          }), this.props.children);
        }

        return i.createElement("div", {
          style: {
            display: "inline-block"
          }
        });
      }, n;
    }(i.Component);

    n.SpinnerComponent = s;
  }, function (e, n) {
    e.exports = require("react");
  }]);
});